import SystemFieldProto from '../../proto/system-field-proto';

import ListComponent from './components/project-health-list';
import ViewComponent from './components/project-health-view';

//projects only field
export default class ProjectHealthField extends SystemFieldProto {

    constructor(entityType) {
        super(entityType);
        this.type = gd.const.fields.type.PROJECT_HEALTH;
    }

    get sortHintMessage() {
        return 'Sort by health';
    }

    getCsvValue(item) {
        return item.health;
    }

    listItemSortFunctions(sort) {
        return {
            functions: [i => {
                console.log("ProjectHealthField listItemSortFunctions", i.item.health);
                return i.item.health;
            }],
            directions: [sort]
        }
    }

    get ListComponent() {
        return ListComponent.bind(null);
    }

    get ViewComponent() {
        return ViewComponent.bind(null);
    }
}